/**
 * @generated SignedSource<<87be75ee1cfa743bf5cd7e035cd8d377>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useContentAppearanceFragment_content$data = Result<{
  readonly appearanceDraft: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useContentAppearanceFragment_content";
}, unknown>;
export type useContentAppearanceFragment_content$key = {
  readonly " $data"?: useContentAppearanceFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentAppearanceFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useContentAppearanceFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "appearanceDraft",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "content-appearance-draft"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "number"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "properties(key:\"content-appearance-draft\")"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "c645e0efb6456131245a0289a6ac421a";

export default node;
